var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 14,
    height: 11,
    fill: "url(#paint0_linear_6853_16923)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81126 10.2L4.80169 17.1413C4.80018 18.2813 5.69734 19.2051 6.80287 19.2037L17.1897 19.1885C18.2858 19.1864 19.1833 18.2617 19.1854 17.1322L19.195 10.1909C19.1965 9.05097 18.2994 8.12713 17.1938 8.12856L6.80702 8.14376C5.70586 8.14612 4.8131 9.06526 4.81126 10.2V10.2Z",
    stroke: "#353535",
    strokeWidth: 1.5818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.6659H19.1248M12 7.79883V18.7988",
    stroke: "#353535",
    strokeWidth: 1.5818
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4V4C11.1046 4 12 4.89543 12 6V8H10C8.89543 8 8 7.10457 8 6V6C8 4.89543 8.89543 4 10 4Z",
    stroke: "#353535",
    strokeWidth: 1.5818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4V4C15.1046 4 16 4.89543 16 6V6C16 7.10457 15.1046 8 14 8H12V6C12 4.89543 12.8954 4 14 4Z",
    stroke: "#353535",
    strokeWidth: 1.5818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6853_16923",
    x1: 5,
    y1: 8,
    x2: 30.0398,
    y2: 11.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift_card.18d0265aa1435137bf54970a70c5d4ea.svg";
export { ForwardRef as ReactComponent };